<template>
  <div>
    <slot :option="option"
          :index="index"
          :has-jump="hasJump"
          :jump-index="jumpIndex"></slot>
  </div>
</template>

<script>
export default {
  components: {},
  provide () {
    return {
      SjQuestionOptionItem: this,
    }
  },
  inject: ['SjQuestion', 'SjQuestionOption'],
  props: {
    prop: Number,
  },
  data () {
    return {}
  },
  computed: {
    index () {
      return this.prop
    },
    option () {
      return this.SjQuestionOption.options[this.index]
    },
    hasJump () {
      return !!this.option.jumpTargetId
    },
    jumpIndex () {
      return this.option.jumpTargetId && this.SjQuestion.questions.findIndex(({id}) => id === this.option.jumpTargetId)
    },
  },
  watch: {},
  created () {},
  mounted () {},
  destroyed () {},
  methods: {},
  filters: {},
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/question-editor/packages/sj-question-option/src/SjQuestionOptionItem.vue